{
  "colorSwatchPicker": "Цветовые образцы",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Выберите элемент",
  "tableResizer": "Средство изменения размера"
}
